import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'team/:id',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/TeamContainer',
      './modules/team'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Team = require('./containers/TeamContainer').default
      const actions = require('./modules/team')
      const reducer = require('./modules/team').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'team', reducer: reducer })

      store.dispatch(actions.fetchTeam(nextState.params.id))

      /*  Return getComponent   */
      cb(null, Team)

    /* Webpack named bundle   */
    }, 'team')
  }
})




// WEBPACK FOOTER //
// ./src/routes/Team/index.js